/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ status: NonNullable<unknown> }} Project_Import_StatusInputs */



/**
* | output |
* | --- |
* | "Importing Project \| {status}" |
*
* @param {Project_Import_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_import_status = /** @type {((inputs: Project_Import_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Import_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Importation du projet | ${i?.status}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Projekt wird importiert | ${i?.status}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione del progetto | ${i?.status}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Проект импорта | ${i?.status}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Importando Proyecto | ${i?.status}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入项目 | ${i?.status}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プロジェクトのインポート | ${i?.status}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात हो रहा है | ${i?.status}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Projeto de Importação | ${i?.status}`)
	return /** @type {LocalizedString} */ (`Importing Project | ${i?.status}`)
});